export default __webpack_public_path__ + "static/media/poke.93926b1c.png";